import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import { getMealCategory } from 'helpers/externalDataSources';
import { standardsSelector } from 'modules/PatientResults/selectors';
import styles from './ReadingValue.pcss';
const ReadingValue = ({ reading, conversion })=>{
    const { value, isManual, flags } = reading;
    const { preMeal, postMeal } = useSelector(standardsSelector);
    const targetObj = flags === 'PostMeal' ? postMeal : preMeal;
    const acceptableFlags = [
        getMealCategory(1),
        getMealCategory(2),
        getMealCategory(3)
    ];
    const screenValue = (val)=>conversion.toDisplay(val);
    const readingValue = conversion.toDisplay(value);
    const isReadingLow = readingValue < screenValue(targetObj.lowThreshold);
    const isReadingHigh = readingValue > screenValue(targetObj.highThreshold);
    const valueClasses = {
        [styles['reading--low']]: isReadingLow,
        [styles['reading--high']]: isReadingHigh,
        [styles['reading--manual']]: isManual
    };
    const icon = acceptableFlags.includes(flags) && /*#__PURE__*/ _jsx(ReadingFlagIcon, {
        flag: flags,
        className: "btn__icon"
    });
    return /*#__PURE__*/ _jsxs("span", {
        className: cn(styles.reading, valueClasses),
        children: [
            icon,
            /*#__PURE__*/ _jsx("span", {
                className: styles.reading__value,
                children: readingValue
            })
        ]
    });
};
export default withStyles(styles)(ReadingValue);
